package com.ives.modules.compare;

import com.ives.modules.info.Info;
import com.ives.utils.Remoting.DicomImageData;
import com.er453r.hxcompo.Component;
import js.html.DragEvent;

import com.ives.components.thumb.DicomThumb;
import com.ives.utils.Log;
class CompareRow extends Component {
	private var dicomImageData:DicomImageData;

	public function new(dicomImageData:DicomImageData) {
		this.dicomImageData = dicomImageData;

		on("dragstart", dragstart);

		append(new DicomThumb(dicomImageData.id));

		date.innerHTML = DateTools.format(Date.fromTime(dicomImageData.studyDate), "%Y/%m/%d %H:%M") + '<br/>' + Info.fillMissing(dicomImageData.institutionName);
	}

	private function onCompare(){
		dispatch("compare", dicomImageData);
	}

	private function dragstart(event:DragEvent){
		event.dataTransfer.setData("source", dicomImageData.sourceName);
		event.dataTransfer.setData("id", dicomImageData.id);

		Log.info("Drag START " + event.dataTransfer.types);
	}
}
